import {BaseCard} from "@/components/BaseCard";
import {CAMPAIGN_CATEGORIES, CAMPAIGN_STATUSES} from "@/constants/push.constants";
import type {CampaignCategory, CampaignFilters as CampaignFiltersType, CampaignStatus} from "@/types/push.types";

interface CampaignFiltersProps {
  filters: CampaignFiltersType;
  onChange: (filters: Partial<CampaignFiltersType>) => void;
}

export const CampaignFilters = ({filters, onChange}: CampaignFiltersProps) => {
  return (
    <BaseCard padding="md">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Status Filter */}
        <div>
          <label
            htmlFor="status-filter"
            className="block text-xs font-medium mb-1.5"
            style={{color: "var(--color-text-secondary)"}}
          >
            Status
          </label>
          <select
            id="status-filter"
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={{
              backgroundColor: "var(--color-bg)",
              border: "1px solid var(--color-surface-2)",
              color: "var(--color-text)",
            }}
            value={filters.status ?? ""}
            onChange={e => onChange({status: e.target.value ? (e.target.value as CampaignStatus) : undefined})}
          >
            <option value="">All Statuses</option>
            {CAMPAIGN_STATUSES.map(status => (
              <option
                key={status.value}
                value={status.value}
              >
                {status.label}
              </option>
            ))}
          </select>
        </div>

        {/* Category Filter */}
        <div>
          <label
            htmlFor="category-filter"
            className="block text-xs font-medium mb-1.5"
            style={{color: "var(--color-text-secondary)"}}
          >
            Category
          </label>
          <select
            id="category-filter"
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={{
              backgroundColor: "var(--color-bg)",
              border: "1px solid var(--color-surface-2)",
              color: "var(--color-text)",
            }}
            value={filters.category ?? ""}
            onChange={e => onChange({category: e.target.value ? (e.target.value as CampaignCategory) : undefined})}
          >
            <option value="">All Categories</option>
            {CAMPAIGN_CATEGORIES.map(cat => (
              <option
                key={cat.value}
                value={cat.value}
              >
                {cat.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date From */}
        <div>
          <label
            htmlFor="date-from-filter"
            className="block text-xs font-medium mb-1.5"
            style={{color: "var(--color-text-secondary)"}}
          >
            Date From
          </label>
          <input
            type="date"
            id="date-from-filter"
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={{
              backgroundColor: "var(--color-bg)",
              border: "1px solid var(--color-surface-2)",
              color: "var(--color-text)",
            }}
            value={filters.date_from ?? ""}
            onChange={e => onChange({date_from: e.target.value || undefined})}
          />
        </div>
      </div>
    </BaseCard>
  );
};
